import type { Input } from '@builder.io/sdk';

const quizFields = [
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'questions',
    type: 'list',
    subFields: [
      {
        name: 'question',
        type: 'string',
      },
      {
        name: 'answer',
        type: 'string',
      },
      {
        name: 'description',
        type: 'string',
      },
      {
        name: 'questionType',
        type: 'string',
        enum: ['True/False', 'Multiple Choice'],
      },
      {
        name: 'options',
        type: 'reference',
        model: 'quiz-options',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const quizConfig = {
  name: 'Quiz',
  inputs: quizFields,
};

export type QuizProps = GenerateBuilder<typeof quizFields>;

export default quizConfig;
